export default "__VITE_ASSET__CQduVLZA__"